/* __next_internal_client_entry_do_not_use__ ResponsiveContent auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";
import { useViewport } from "./hooks/useViewport";
/**
 * This component can be used to conditionally display content based on the viewport without using
 * useViewport or Viewport.getDefault(). It uses responsiveMediaQueries to only display the component
 * assigned to the current viewport in case of SSR of if explicitly set through the "noJS" prop
 * @deprecated Use `@faire/web--source/ui/ResponsiveContentV2#ResponsiveContentV2`
 * @supersededBy "@faire/web--source/ui/ResponsiveContentV2#ResponsiveContentV2"
 * @trackcomponent
 */ export var ResponsiveContent = function(props) {
    var mobile = props.mobile, desktop = props.desktop, noJS = props.noJS;
    var isSSR = useIsSSR();
    var viewport = useViewport();
    if (isSSR || noJS) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(MobileOnly, {
                    children: mobile
                }),
                /*#__PURE__*/ _jsx(DesktopOnly, {
                    children: desktop
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: viewport.isMobile ? mobile : desktop
    });
};
var MobileOnly = styled.span.withConfig({
    componentId: "sc-7f10587f-0"
})([
    "display:inline-block;",
    "{display:none;}"
], responsiveMediaQueries.tabletAndAbove);
var DesktopOnly = styled.span.withConfig({
    componentId: "sc-7f10587f-1"
})([
    "display:inline-block;",
    "{display:none;}"
], responsiveMediaQueries.mobile);
